import { SVGAttributes } from 'react';
import { useTheme } from '@context/ThemeProvider';
import { IconName } from '@constants/themes';
import { ICON_SETS } from '@themes/IconSets';

type IconProps = {
  name: IconName;
  className?: string;
} & SVGAttributes<SVGElement>;

export const ThemedIcon = ({ name, ...props }: IconProps) => {
  const { theme } = useTheme();
  const Icon = ICON_SETS[theme]?.[name];

  if (!Icon) return null;
  return <Icon {...props} />;
};

export default ThemedIcon;
